function autoSize(e) {
    e.target.style.height = `${e.target.contentWindow.document.body.scrollHeight}px`
}

export default {
    bind: function (el) {
        if (el.tagName.toLowerCase() === 'iframe') {
            el.addEventListener('load', autoSize)
        }
    },
    unbind: function (el) {
        el.removeEventListener('load', autoSize)
    },
}
